import { getOpensOrders, OpenOrdersApiParameter } from "@dana/Services/DanaOrderRelatedService";
import {OpenOrdersActions} from "@dana/Store/Data/OpenOrders/Reducers/GetOpenOrdersReducer";
import { BackorderResponse } from "@dana/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type OpenOrderRequestParameter = {
    customerNumber?: string;      
}& HasOnSuccess<any> & HasOnError;


type HandlerType =ApiHandlerDiscreteParameter<OpenOrderRequestParameter,OpenOrdersApiParameter,BackorderResponse, DispatchProp<OpenOrdersActions>>;

export const SetLoadingOn: HandlerType = props => {
    props.dispatch?.({
        type: "OpenOrders/IsLoading",
        isLoading: true,
    });
}

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getOpensOrders({
        customerNumber:props.parameter.customerNumber,
    });   
};

export const PopulateFacetResult: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch?.({
            type: "OpenOrders/PopulateResult",              
            data: props.apiResult,
        } as any);
    }
}

export const chain = [SetLoadingOn,SendDataToApi, PopulateFacetResult];

const GetOpenOrdersData = createHandlerChainRunner(chain, "GetOpenOrdersData");
export default GetOpenOrdersData;